const cart = document.querySelector(".cart-drawer");
const openCartButtons = document.querySelectorAll("[data-cart-open]");
const closeCartButtons = document.querySelectorAll("[data-cart-close]");
const buyButtons = document.querySelectorAll("[data-nightkind-buy]");
const root = document.querySelector("[data-nightkind-product-handle]");
const productHandle = root?.dataset.nightkindProductHandle || "nightkind-clinical-sleep-support";
const themeChromeSelectors = [
  ".shopify-section-group-header-group",
  ".shopify-section-group-footer-group",
  ".shopify-section-header",
  ".shopify-section-footer",
  "[id^='shopify-section-nl-']",
  "#shopify-section-nl-header",
  "[id^='shopify-section-header']",
  "[id^='shopify-section-footer']",
  "[id*='__header']",
  "[id*='__footer']",
  "header[role='banner']",
  "footer[role='contentinfo']",
  ".site-header",
  ".site-footer",
];

document.documentElement.classList.add("nightkind-active");
document.body?.classList.add("nightkind-active");
hideThemeChrome();

function openCart() {
  cart?.classList.add("is-open");
  cart?.setAttribute("aria-hidden", "false");
}

function closeCart() {
  cart?.classList.remove("is-open");
  cart?.setAttribute("aria-hidden", "true");
}

function hideThemeChrome() {
  document.querySelectorAll(themeChromeSelectors.join(",")).forEach((element) => {
    if (element.closest(".nightkind-template")) return;
    element.setAttribute("hidden", "");
    element.style.display = "none";
  });
}

openCartButtons.forEach((button) => button.addEventListener("click", openCart));
closeCartButtons.forEach((button) => button.addEventListener("click", closeCart));
buyButtons.forEach((button) => {
  button.addEventListener("click", () => addNightkindToCart(button));
});

cart?.addEventListener("click", (event) => {
  if (event.target === cart) closeCart();
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeCart();
});

document.querySelectorAll("[data-nightkind-gallery]").forEach(initGallery);
document.querySelectorAll("[data-week-tab]").forEach((tab) => {
  tab.addEventListener("click", () => activateWeek(tab.dataset.weekTab));
});

async function addNightkindToCart(button) {
  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = "Adding...";

  try {
    const productResponse = await fetch(`/products/${productHandle}.js`, {
      headers: { Accept: "application/json" },
    });

    if (!productResponse.ok) throw new Error(`Missing product ${productHandle}`);

    const product = await productResponse.json();
    const variant = product.variants.find((item) => item.available) || product.variants[0];
    if (!variant) throw new Error("No product variant available");

    const cartResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variant.id, quantity: 1 }),
    });

    if (!cartResponse.ok) throw new Error("Cart add failed");

    button.textContent = "Added";
    openCart();
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 900);
  } catch (error) {
    console.error(error);
    button.textContent = "Product not ready";
    openCart();
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 1600);
  }
}

function initGallery(gallery) {
  const track = gallery.querySelector("[data-gallery-track]");
  const slides = [...gallery.querySelectorAll(".gallery-slide")];
  const thumbs = [...gallery.querySelectorAll("[data-gallery-index]")];
  const prev = gallery.querySelector("[data-gallery-prev]");
  const next = gallery.querySelector("[data-gallery-next]");
  if (!track || !slides.length) return;

  let activeIndex = 0;

  const setActive = (index, shouldScroll = true) => {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach((slide, slideIndex) => slide.classList.toggle("is-active", slideIndex === activeIndex));
    thumbs.forEach((thumb) => thumb.classList.toggle("active", Number(thumb.dataset.galleryIndex) === activeIndex));
    if (shouldScroll) {
      slides[activeIndex].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    }
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => setActive(Number(thumb.dataset.galleryIndex)));
  });
  prev?.addEventListener("click", () => setActive(activeIndex - 1));
  next?.addEventListener("click", () => setActive(activeIndex + 1));

  let scrollTimer;
  track.addEventListener("scroll", () => {
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const nextIndex = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      setActive(nextIndex, false);
    }, 80);
  });
}

function activateWeek(index) {
  document.querySelectorAll("[data-week-tab]").forEach((tab) => {
    const isActive = tab.dataset.weekTab === String(index);
    tab.classList.toggle("active", isActive);
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
  });
  document.querySelectorAll("[data-week-panel]").forEach((panel) => {
    panel.classList.toggle("active", panel.dataset.weekPanel === String(index));
  });
}
